import { KNOLIA } from "@/knolia"
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({ user: {}, countValidations: 0 }),

    getters: {
        User: (state) => state.user,
        CountValidations: (state) => state.countValidations
    },

    actions: {
        async GetUser() {
            const res = await KNOLIA.CallBackEnd("post", "get-user", { params: { self: true } })
            this.user = res.data.user
        },

        resetUser() {
            this.user = {}
        },

        SetCountValidations(countValidations) {
            this.countValidations = countValidations
        },
    }
})
